'use strict'

import reportService from '@/services/report'
/** 创建a标签下载 */
export function downloadCsvAsync (url, target = '_self', filename = 'export.csv') {
  if (!url) return
  const hiddenElement = document.createElement('a')
  hiddenElement.href = url
  hiddenElement.target = target
  hiddenElement.download = filename
  hiddenElement.click()
}
/** 轮询报表是否导出完成 */
async function downloadReportCsv (id, filename, onSuccess, onError, downState) {
  const debounce = true
  try {
    const { data: res } = await reportService.downloadReportCsv(id, debounce)
    const { status, percentage, url } = res.data.reportBody
    downState.downloadCsvPercentage = percentage

    if (status === 'COMPLETED') {
      downloadCsvAsync(url, '_self', filename)
      clearInterval(downState.downloadCsvAutoRequest)
      downState.downloadCsvPercentage = 0
      onSuccess()
    } else if (status === 'ERROR' || status === 'DELETED') {
      throw new Error()
    }
  } catch (err) {
    onError()
    console.log('Error', err)
    clearInterval(downState.downloadCsvAutoRequest)
  }
}
/** 发起导出请求 */
export async function exportAsync (params, filename, onSuccess, onError, downState) {
  try {
    const { data: res } = await reportService.exportValidate(params)
    if (res.data) {
      downState.downloadCsvAutoRequest = setInterval(() => {
        downloadReportCsv(res.data, filename, onSuccess, onError, downState)
      }, 2000)
    }
  } catch (err) {
    console.log('Error', err)
    onError()
    clearInterval(downState.downloadCsvAutoRequest)
  }
}
